// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  // Kill switch: set true + redeploy to halt all new orders (e.g. during a backend outage).
  ordersDisabled: false,
  appServiceUrl: 'https://appservice.test.igive.xyz',
  giftRevealBaseUrl: 'https://test.minegavekort.app',
  plausible: {
    enabled: false
  },
  // igive.no's test deployment of the consent banner. It writes a host-only
  // record, so no answer given on staging becomes a production answer.
  consentScriptUrl: 'https://test.igive.no/consent/v1.js',
  // The Meta pixel loads only behind the markedsforing consent, only on the
  // production host, and only once an id is set here. Staging builds use this
  // file, so nothing here ever sends to Meta.
  meta: {
    pixelId: null as string | null
  },
  // The Google Ads purchase conversion loads only behind the markedsforing
  // consent and only on the production host. See GoogleAdsService.
  googleAds: {
    sendTo: null as string | null
  },
  sentry: {
    dsn: null as string | null,
    tracesSampleRate: 0
  },
  // Invoice orderers confirm who they are with Vipps Login, and orders go to
  // the v7 order API. Off while clientId is null: invoice orders then ask for
  // the name as before, on v6. The client id is public (it is in every login
  // link); the secret lives only in api-appservice. Test sales unit 328518.
  vippsLogin: {
    clientId: '2288110e-74bb-4c36-96fe-c9938b10bc26' as string | null,
    authorizationEndpoint: 'https://apitest.vipps.no/access-management-1.0/access/oauth2/auth'
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
